var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$utils.isMobile() ? 'cpt-change-lang-m' : 'cpt-change-lang',on:{"click":_vm.switchLanguage}},[(_vm.$i18n.locale == 'en-US')?_c('img',{staticClass:"img-box",attrs:{"src":require("../assets/lang-en.png"),"alt":""}}):_c('img',{staticClass:"img-box",attrs:{"src":require("../assets/lang-zh.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }